import { LOCAL_DATE } from './date-time.constants';

export const DEFAULT_DATERANGEPICKER_FORMAT = LOCAL_DATE;
